var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_c('v-select',{ref:"select",attrs:{"options":_vm.actions,"label":"label"},on:{"option:selected":function($event){return _vm.execute($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }